var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-card text-center"},[_c('div',{staticClass:"ob-check-circle mx-auto"},[_c('i',{staticClass:"fa-solid fa-check"})]),_vm._v(" "),_c('p',{staticClass:"ob-subtitle mt-4"},[_vm._v("Vamos a construir tu sueño")]),_vm._v(" "),_c('p',{staticClass:"ob-footer"},[_vm._v("GRUPO TERRAZON SAPI DE CV")])])
}]

export { render, staticRenderFns }